import React from 'react'
import { useNavigate } from 'react-router-dom'

import AddDarazStore from 'app/common/Stores/Daraz/AddDarazStore'
import AddShopifyStore from 'app/common/Stores/Shopify/AddShopifyStore'
import AddWooCommerceStore from 'app/common/Stores/Woo/AddWooCommerceStore'
import { OnBoardingContext } from 'client/contexts/OnBoardingContext'
import {
  PixelButton,
  PixelFactoryContext,
  PixelFlexBox,
  colors,
  DcButton,
  DcText,
  PixelText,
  DcDiv,
} from 'pixel-base'
import queryString from 'query-string'
import { AjaxResponse } from 'rxjs/ajax'
import styled from 'styled-components'
import { registerCustomerStore, verifyConnection } from 'utils/api-routes.util'

import StoreDaraz from 'utils/icons/store-daraz'
import StoreShopify from 'utils/icons/store-shopify'
import StoreWoocom from 'utils/icons/store-woocom'
import ManualFlow from './ManualFlow'

import {
  HelperWebSection,
  InFlowActions,
  InFlowContainer,
  InFlowDescription,
  InFlowTitle,
  Store,
} from './stores.styled'
import { IPixelFactory } from '../../../../../decl.d'

const ShopifyFlow = 'list' // environment.SHOPIFY_FLOW;

const stores = [
  {
    name: 'Shopify',
    slug: 'shopify',
    description: '',
    icon: <StoreShopify />,
    is_active: false,
    id: 2,
    activeFlow: `${ShopifyFlow}`,
  },
  {
    name: 'Daraz',
    slug: 'daraz',
    description: '',
    icon: <StoreDaraz />,
    is_active: false,
    id: 3,
    activeFlow: 'list',
  },
  {
    name: 'WooCommerce',
    slug: 'woocommerce',
    description: '',
    icon: <StoreWoocom />,
    is_active: true,
    id: 1,
    activeFlow: 'list',
  },
]

const Stores = ({
  onStoreTypeSelect,
  onWithoutWebsite,
  selectedStoreType,
  ...props
}) => {
  const { activeStep, setActiveStep } = React.useContext(OnBoardingContext)
  const [activestore, setactivestore] = React.useState(stores[0])
  const [activeView, setActiveView] = React.useState<
    string | 'list' | 'in-flow' | 'manual'
  >(activestore.activeFlow)

  const handleNextStep = () => {
    if (onWithoutWebsite) {
      onWithoutWebsite()
    } else {
      setActiveStep(activeStep + 1)
    }
  }
  const [connectionStatus, setConnectionStatus] = React.useState<any>({
    available: false,
    status: '',
    verifying: true,
    success: 0,
  })
  const { showPageLoader, hidePageLoader } =
    React.useContext<IPixelFactory>(PixelFactoryContext)

  const [validatedData, setValidatedData] = React.useState({
    auth_url: '',
    favicon: '',
    id: 0,
    title: '',
    url: '',
    validated: false,
  })
  const p = queryString.parse(window.location.search)

  // Handle store type selection from parent component
  React.useEffect(() => {
    if (selectedStoreType) {
      const store = stores.find((s) => s.slug === selectedStoreType)
      if (store) {
        setactivestore(store)
        setActiveView(store.activeFlow)
      }
    }
  }, [selectedStoreType])

  React.useEffect(() => {
    const parsedQueryData: any = p
    if (parsedQueryData.success) {
      setActiveView('in-flow')
      const isInitialSuccess = parsedQueryData.success == '1'
      setConnectionStatus({
        ...parsedQueryData,
        available: true,
        verifying: isInitialSuccess,
        status: isInitialSuccess ? '' : 'error',
        success: isInitialSuccess ? 1 : 0,
      })

      if (isInitialSuccess) {
        verifyConnection(parsedQueryData).subscribe({
          next: (res: any) => {
            if (res.response.verified) {
              setConnectionStatus((prev) => ({
                ...prev,
                available: true,
                verifying: false,
                success: 1,
              }))
              window.history.replaceState(
                {},
                document.title,
                window.location.pathname,
              )
            } else {
              setConnectionStatus((prev) => ({
                ...prev,
                available: true,
                verifying: false,
                success: 0,
                error: 'Verification failed. Please try again or add manually.',
              }))
            }
          },
          error: (err) => {
            console.error('Verification failed:', err)
            setConnectionStatus((prev) => ({
              ...prev,
              available: true,
              verifying: false,
              success: 0,
              error: 'Failed to verify connection. Please try again.',
            }))
          },
        })
      }
    }
    const store_type = parsedQueryData.type || parsedQueryData.store_type
    if (parsedQueryData.type || parsedQueryData.store_type) {
      const lastShopifyStore = JSON.parse(
        localStorage.getItem('lastShopifyStore') || '{}',
      )
      const lastWooCStore = JSON.parse(
        localStorage.getItem('lastWooCStore') || '{}',
      )
      const lastDarazStore = JSON.parse(
        localStorage.getItem('lastDarazStore') || '{}',
      )
      if (store_type == '3') {
        setValidatedData(lastDarazStore)
      }
      if (store_type == '2') {
        setValidatedData(lastShopifyStore)
      }

      if (store_type == '1') {
        setValidatedData(lastWooCStore)
      }
      const activeStore = stores?.find((item) => item.id == store_type)
      if (activeStore) {
        setactivestore(activeStore)
      }
    }
  }, [])

  const handleConnectClick = () => {
    window.open(validatedData.auth_url, '_blank')
  }
  const navigate = useNavigate()

  const resetFlow = () => {
    setActiveView('list')
    setConnectionStatus({ available: false, status: '', verifying: true })
    setValidatedData({
      auth_url: '',
      favicon: '',
      id: 0,
      title: '',
      url: '',
      validated: false,
    })
    setactivestore(stores[0])
    navigate('/onboarding?step=1')
  }
  const onUpdateInfo = () => {
    handleWithoutWebsiteClick()
  }

  // Handle store selection
  const handleStoreSelect = (store) => {
    if (onStoreTypeSelect) {
      onStoreTypeSelect(store.slug)
    } else {
      setactivestore(store)
      setActiveView(store.activeFlow)
    }
  }

  // Handle without website option
  const handleWithoutWebsiteClick = () => {
    // Call /tenant/stores/ems endpoint directly
    showPageLoader()
    registerCustomerStore({ store_type: 'ems' }).subscribe(
      (res: AjaxResponse<any>) => {
        hidePageLoader()
        // Set flag to indicate user came from "without website" flow
        localStorage.setItem('fromWithoutWebsite', 'true')
        if (onWithoutWebsite) {
          onWithoutWebsite()
        } else {
          setActiveStep(activeStep + 1)
        }
      },
      (error) => {
        hidePageLoader()
        console.error('Error registering EMS store:', error)
        // Still proceed even if EMS registration fails
        localStorage.setItem('fromWithoutWebsite', 'true')
        if (onWithoutWebsite) {
          onWithoutWebsite()
        } else {
          setActiveStep(activeStep + 1)
        }
      },
    )
  }

  return (
    <PixelFlexBox
      flexDirection="column"
      justifyContent="stretch"
      alignItems="stretch"
      style={{
        flexFlow: 'inherit',
        overflow: 'auto',
      }}
      position="relative"
      margin="10px 0 10px 0"
      height="auto"
    >
      <PixelFlexBox
        flexDirection="column"
        alignItems={activeView == 'in-flow' ? 'center' : 'stretch'}
        justifyContent={activeView == 'in-flow' ? 'center' : 'center'}
        height="auto"
      >
        {activeView != 'in-flow' && (
          <PixelFlexBox
            width="100%"
            flexDirection="column"
            justifyContent="center"
            alignItems="flex-end"
          >
            <PixelFlexBox
              flexDirection="column"
              justifyContent="space-evenly"
              alignItems="flex-end"
              alignContent="center"
              gap="15px"
              height="auto"
            >
              <PixelFlexBox
                width="100%"
                flexDirection="row"
                alignItems="center"
                justifyContent="flex-start"
                height="60px"
                style={{
                  border: `1px solid ${colors.grayBorderLight}`,
                  borderRadius: '5px',
                  padding: '0 5px',
                }}
                gap="10px"
              >
                {stores.map((store) => (
                  <Store
                    key={store.slug}
                    className={store.id === activestore.id ? 'active' : ''}
                    onClick={() => handleStoreSelect(store)}
                  >
                    {store.icon}
                  </Store>
                ))}
              </PixelFlexBox>
            </PixelFlexBox>
          </PixelFlexBox>
        )}

        <PixelFlexBox
          width={'100%'}
          flexDirection="column"
          justifyContent="center"
          alignContent="center"
          alignItems="center"
          height="auto"
        >
          <PixelFlexBox width="100%" flexDirection="column" alignItems="center">
            {activeView === 'list' ? (
              <>
                {activestore.id === 1 && (
                  <AddWooCommerceStore origin="onboarding" />
                )}
                {activestore.id === 2 && (
                  <AddShopifyStore origin="onboarding" />
                )}
                {activestore.id === 3 && <AddDarazStore origin="onboarding" />}
              </>
            ) : activeView === 'in-flow' ? (
              <>
                <InFlowContainer>
                  {connectionStatus?.success == 0 ? (
                    <>
                      <InFlowTitle>{'You are still not connected'}</InFlowTitle>
                      {connectionStatus?.error && (
                        <DcText
                          customColor={colors.danger}
                          style={{
                            margin: '10px auto',
                            maxWidth: '400px',
                            textAlign: 'center',
                          }}
                        >
                          {connectionStatus.error}
                        </DcText>
                      )}
                      <InFlowDescription>
                        {'You have not finished connecting '}
                        <strong>{validatedData.url || 'your store'}</strong>
                        {' to PixelOne.'} <br />
                        <br />
                        {`Click the button below to continue or cancel if you'd
                        like to add another store.`}
                      </InFlowDescription>
                      <InFlowActions>
                        <PixelButton onClick={handleConnectClick}>
                          Connect
                        </PixelButton>
                      </InFlowActions>
                      <DcDiv
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                          marginTop: '20px',
                        }}
                      >
                        <Divider>OR</Divider>
                      </DcDiv>
                      <InFlowActions>
                        <PixelButton variant="secondary" onClick={resetFlow}>
                          Add Another Store
                        </PixelButton>
                        <PixelButton onClick={handleNextStep}>
                          Skip & Continue
                        </PixelButton>
                      </InFlowActions>
                      <HelperWebSection style={{ marginTop: '20px' }}>
                        <PixelText
                          textSize="14px"
                          style={{
                            fontWeight: '400',
                            letterSpacing: 'normal',
                            lineHeight: '19.6px',
                            textAlign: 'center',
                            display: 'inline-flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            gap: '3px',
                          }}
                          customColor={colors.grayTextDark}
                        >
                          {'Selling without website? Click'}
                          <DcButton
                            onClick={handleWithoutWebsiteClick}
                            variant="link"
                            padding="0"
                            style={{
                              fontSize: '.875rem',
                              color: `${colors.primary} !important`,
                            }}
                          >
                            here.
                          </DcButton>
                        </PixelText>
                        <PixelText
                          textSize="14px"
                          style={{
                            fontWeight: '400',
                            letterSpacing: 'normal',
                            lineHeight: '19.6px',
                            textAlign: 'center',
                            display: 'inline-flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            gap: '3px',
                          }}
                          customColor={colors.grayTextDark}
                        >
                          {'Need help? Click to send us message on Whatsapp.'}
                          <a
                            href="https://api.whatsapp.com/send?phone=923205731765"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                              fontSize: '.875rem',
                              color: `${colors.primary} !important`,
                              textDecoration: 'none',
                            }}
                          >
                            here.
                          </a>
                        </PixelText>
                      </HelperWebSection>
                    </>
                  ) : (
                    <>
                      <InFlowTitle>{'You are connected'}</InFlowTitle>
                      <InFlowDescription>
                        {connectionStatus?.verifying ? (
                          'We just need to test the connection to your store. Please wait a few moments...'
                        ) : (
                          <>
                            {`We've confirmed that the connection with `}
                            <strong>{validatedData.url || 'your store'}</strong>
                            {` is functioning correctly.`}
                          </>
                        )}
                      </InFlowDescription>
                      <DcDiv
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                          marginTop: '20px',
                        }}
                      >
                        <Divider>OR</Divider>
                      </DcDiv>
                      <InFlowActions>
                        <PixelButton variant="secondary" onClick={resetFlow}>
                          Add Another Store
                        </PixelButton>
                        <PixelButton onClick={handleNextStep}>
                          {connectionStatus?.verifying
                            ? 'Skip & Continue'
                            : 'Continue'}
                        </PixelButton>
                      </InFlowActions>
                      <HelperWebSection style={{ marginTop: '20px' }}>
                        <PixelText
                          textSize="14px"
                          style={{
                            fontWeight: '400',
                            letterSpacing: 'normal',
                            lineHeight: '19.6px',
                            textAlign: 'center',
                            display: 'inline-flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            gap: '3px',
                          }}
                          customColor={colors.grayTextDark}
                        >
                          {'Need help? Click to send us message on Whatsapp.'}
                          <a
                            href="https://api.whatsapp.com/send?phone=923205731765"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                              fontSize: '.875rem',
                              color: `${colors.primary} !important`,
                              textDecoration: 'none',
                            }}
                          >
                            here.
                          </a>
                        </PixelText>
                      </HelperWebSection>
                    </>
                  )}
                </InFlowContainer>
              </>
            ) : (
              <>
                <ManualFlow
                  activestore={activestore}
                  onBack={resetFlow}
                  onUpdateInfo={onUpdateInfo}
                />
              </>
            )}
          </PixelFlexBox>
        </PixelFlexBox>
      </PixelFlexBox>
      {activeView != 'in-flow' && (
        <>
          <DcDiv style={{ display: 'flex', justifyContent: 'center' }}>
            <Divider>OR</Divider>
          </DcDiv>
          {!validatedData.validated && (
            <HelperWebSection>
              <PixelText
                textSize="14px"
                style={{
                  fontWeight: '400',
                  letterSpacing: 'normal',
                  lineHeight: '19.6px',
                  textAlign: 'center',
                  display: 'inline-flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  gap: '3px',
                }}
                customColor={colors.grayTextDark}
              >
                {'Selling without website? Click'}
                <DcButton
                  onClick={handleWithoutWebsiteClick}
                  variant="link"
                  padding="0"
                  style={{
                    fontSize: '.875rem',
                    color: `${colors.primary} !important`,
                  }}
                >
                  here.
                </DcButton>
              </PixelText>
              <PixelText
                textSize="14px"
                style={{
                  fontWeight: '400',
                  letterSpacing: 'normal',
                  lineHeight: '19.6px',
                  textAlign: 'center',
                  display: 'inline-flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  gap: '3px',
                }}
                customColor={colors.grayTextDark}
              >
                {'Need help? Click to send us message on Whatsapp.'}
                <a
                  href="https://api.whatsapp.com/send?phone=923205731765"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    fontSize: '.875rem',
                    color: `${colors.primary} !important`,
                    textDecoration: 'none',
                  }}
                >
                  here.
                </a>
              </PixelText>
            </HelperWebSection>
          )}
        </>
      )}
    </PixelFlexBox>
  )
}

const Divider = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80%;
  margin: 10px 0;
  font-size: 14px;
  color: ${colors.grayText};
  position: relative;
  text-align: center;

  &::before,
  &::after {
    content: '';
    flex-grow: 1;
    height: 2px;
    background-color: ${colors.grayBorderLight};
    position: relative;
  }

  &::before {
    margin-right: 10px;
  }

  &::after {
    margin-left: 10px;
  }

  @media (min-width: 768px) {
    width: 30%;
  }
`

export default Stores
